import Loader from "../../components/main/Loader";
import { HeaderAgency } from "../../utils/headerTable/TabHeaderAgency";
import { useGetAgenciesQuery } from "../../store/services/AgencyService";
import AgencyAction from "../../components/action/AgencyAction";
import TableComponentPaginationClient from "../../components/main/TablePaginationClient";

export default function AgencyList() {

    const { isSuccess, isLoading, data, isFetching }: any = useGetAgenciesQuery('');

    return (
        <>
            {(isLoading || isFetching) && <Loader />}

            <h2 className="text-xl pt-6">Gestione aziende</h2>

            <div className="flex items-center justify-end">
                <AgencyAction type="add" label="Aggiungi azienda" />
            </div>

            <div className="mt-6">                
                {isSuccess && data?.result.length > 0
                    ? <TableComponentPaginationClient
                        columns={HeaderAgency}
                        data={data.result}
                        type="userList"
                        isDisabledPagination={false}
                    />
                    : <p className="p-6 text-center">NESSUNA AZIENDA PRESENTE</p>
                }
            </div>
        </>
    )
}